import axios from 'axios';

export const addItem = (id, quantity, variant = null, properties = null, measurements = null) => (
  dispatch,
) => {
  dispatch({
    type: 'SET_LOADING',
  });

  const api = '/cart/add.js';
  const params = { items: [{ id, quantity, properties }] };

  return axios.post(api, params)
    .then((res) => {
      const promises = res.data.items.map((lineItem) => dispatch({
        type: 'RECEIVE_ITEM',
        lineItem: {
          ...lineItem,
          measurements,
        },
        variant,
        quantity,
      }));

      return Promise.all([
        ...promises,
        dispatch({
          type: 'UNSET_LOADING',
        }),
      ]);
    })
    .catch((error) => {
      /* eslint-disable no-console */
      console.log(error);
      if (error.response && error.response.data) {
        dispatch({
          type: 'RECEIVE_ITEM_ERROR',
          id,
          error: error.response.data.description,
        });
      }
      dispatch({
        type: 'UNSET_LOADING',
      });
      /* eslint-enable no-console */
    });
};

export const updateItem = (id, quantity) => (dispatch) => {
  dispatch({
    type: 'SET_LOADING',
  });

  const api = '/cart/change.js';
  const params = { id, quantity };
  return axios.post(api, params)
    .then((res) => Promise.all([
      dispatch({
        type: 'UNSET_LOADING',
      }),
      dispatch({
        type: 'RECEIVE_ITEMS',
        items: res.data.items,
      }),
    ]))
    .catch((error, data) => {
      /* eslint-disable no-console */
      console.log(error, data);
      dispatch({
        type: 'UNSET_LOADING',
      });
      /* eslint-enable no-console */
    });
};

export const updateCart = (payload) => (dispatch) => {
  dispatch({
    type: 'SET_LOADING',
  });

  const api = '/cart/update.js';
  return axios.post(api, payload)
    // .then((res) => {
    //   console.log('DONE UPDATE CART');
    //   console.log(res);
    // })
    .then(() => Promise.all([
      dispatch({
        type: 'UNSET_LOADING',
      }),
    ]))
    .catch((error, data) => {
      /* eslint-disable no-console */
      console.log(error, data);
      dispatch({
        type: 'UNSET_LOADING',
      });
      /* eslint-enable no-console */
    });
};

export const toggleOpenCart = () => ({
  type: 'TOGGLE_OPEN_CART',
});

export const populateItems = (items) => ({
  type: 'POPULATE_ITEMS',
  items,
});

export const openCart = () => ({
  type: 'OPEN_CART',
});

export const closeCart = () => ({
  type: 'CLOSE_CART',
});

export const setGiftWrap = () => ({
  type: 'SET_GIFT',
});

export const unsetGiftWrap = () => ({
  type: 'UNSET_GIFT',
});
